'use client';

import Image from 'next/image';
import { useModal, MODAL_TYPES } from '@/components/modal/ModalProvider';

export default function CompanyUSP({ block, position }) {
  const { _metadata, item: itemList } = block.company_usp;
  const { showModal } = useModal();

  const openModal = (item) => {
    showModal(MODAL_TYPES.companyUSP, { item });
  };

  return (
    <section
      id={`${_metadata.uid}-${position}`}
      data-name="company-usp"
      className="grid grid-cols-3 not-last:mb-8"
    >
      {itemList.map((item, index) => {
        return (
          <div key={index}>
            <button
              onClick={() => openModal(item)}
              className="mx-auto block max-w-[96px] transition-opacity duration-300 hover:opacity-75"
            >
              <Image
                src={item.icon.url}
                width="96"
                height="32"
                sizes="96px"
                alt={item.icon.title.replace(/\.[^/.]+$/, '')}
                className="mx-auto h-8 w-32"
              />
              <div className="body-xs text-center text-white">{item.title}</div>
            </button>
          </div>
        );
      })}
    </section>
  );
}
